// @ts-nocheck
import axios from "axios";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import ReactLoading from 'react-loading';
import { getAnalytics, logEvent } from 'firebase/analytics';
// @ts-ignore
import useGeoLocation from "react-ipgeolocation";
import "react-phone-input-2/lib/style.css";
import { useHistory } from "react-router-dom";
export default function Congratulations(props) {

	const history = useHistory()

	const analytics = getAnalytics();
	const [error, setError] = useState('')
	const [isEmailOk, setIsEmailOk] = useState("")
	const location = useGeoLocation();
	const [Loader, setLoader] = useState(true)
	const [newFormData, setNewFormData] = useState('')
	// @ts-ignore
	const [phoneData, setPhoneData] = useState(null);
	// @ts-ignore
	const [code, setcode] = useState(undefined);

	const [isDisable, setisDisable] = useState(true);
	const [isOnlineClass,setIsOnlineClass] = useState(null)
	const [formData, setFormData] = useState({
		email: null,
		name: null,
		mobile: null,
		isd: null,
		
	});

	const check = (data) => {
		let flag = false;
		Object.keys(data).forEach((item) => {


			if (/^[A-Za-z0-9+_.-]+@(.+)$/.test(data[item])) {
				setIsEmailOk("ok")
				console.log("ok")
			}

			if (isEmailOk == "ok") {
				console.log("mbloutside")
				if ((formData?.mobile?.length ?? 0) >= 5 && !!isOnlineClass) {
					console.log("mbl");
					setisDisable(false);
				  }
			}
		});
		// return flag;
	};
	const handleFormData = (e) => {
		const name = e.currentTarget.name;
		const value = e.currentTarget.value;

		setFormData((prev) => {
			const newData = { ...prev };
			newData[name] = value;
			check(newData)

			return newData;
		});

	};
	// const handleFormData = (e) => {
	// 	const { name, value } = e.target;
	  
	// 	setFormData((prev) => ({
	// 	  ...prev,
	// 	  [name]: value,
	// 	}));
	//   };
	// @ts-ignore
	const handleChange = (value, data, event, formattedValue) => {
		const mobile = value.slice(data.dialCode.length)
		setPhoneData(mobile)
		setFormData((prev) => ({ ...prev, mobile }))
		setcode(data.dialCode);
	};


	useEffect(() => {
		check(formData)

	}, [formData.mobile, isOnlineClass])

	const popupCenter = (url, title, w, h) => {
		// Fixes dual-screen position     Most browsers      Firefox
		// console.log(url)
		const dualScreenLeft =
			window.screenLeft !== undefined
				? window.screenLeft
				: window.screenX;
		const dualScreenTop =
			window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth
			? window.innerWidth
			: document.documentElement.clientWidth
				? document.documentElement.clientWidth
				: window.screen.width;
		const height = window.innerHeight
			? window.innerHeight
			: document.documentElement.clientHeight
				? document.documentElement.clientHeight
				: window.screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;


		if (
			navigator.userAgent
				.toLowerCase()
				.match(/(ipad|iphone|safari)/) &&
			navigator.userAgent.search("Chrome") < 0
		) {
			setTimeout(() => {
				window.open(url, "_self");
			})
		} else {
			const newWindow = window.open(
				url,
				title,
				`
		  scrollbars=yes,
		  width=${w / systemZoom}, 
		  height=${h / systemZoom}, 
		  top=${top}, 
		  left=${left}
		  `
			);
			if (window.focus) newWindow.focus();
		}
	};
	const handleSubmitPay = () => {
		setLoader(false)
		let data = formData;
		data['isd'] = code;
		data['packageId'] = process.env.REACT_APP_PACKAGE_ID;
		if (process.env.REACT_APP_PROMOTION_ID != "null") {
			data['promotionId'] = process.env.REACT_APP_PROMOTION_ID;
		}

		const submitData = JSON.stringify(data);
		const privyrData =  JSON.stringify({...data,lead_source: "Red2 Page",phone:phoneData})

		// let config = {
		// 	method: 'post',
		// 	maxBodyLength: Infinity,
		// 	url: 'https://www.privyr.com/integrations/api/v1/incoming-webhook',
		// 	headers: { 
		// 	  'X-TOKEN': 'hp4iWYK7', 
		// 	  'Content-Type': 'application/json'
		// 	},
		// 	data : privyrData
		//   };
		  
		//   axios(config)
		//   .then((response) => {
		// 	console.log(response)
		// 	console.log(JSON.stringify(response.data));
		//   })
		//   .catch((error) => {
		// 	console.log(error);
		//   });

		TeleCRMLeads()

		axios
			.post(
				// @ts-ignore
				process.env.REACT_APP_JOIN_NOW_URL,
				submitData,

				{
					headers: {
						"Content-Type": "application/json",
					},
				}
			)
			.then((res) => {
				logEvent(analytics, 'User Details Red3',data)
				if (res.data.message === 'Package not applicable for actively enrolled users.') {
					setError("Already enrolled")
					setisDisable(true)
				}
				else {
					const paymentLink = res?.data?.data?.paymentLink;
					// popupCenter(paymentLink, "Payment for Red", 600, 700);

					
					// if (paymentLink) {
						const NewFormData = {
							...data, campaignId: process.env.REACT_APP_CAMPAIGNID, paymentUrl: paymentLink, packageId: process.env.REACT_APP_PACKAGE_ID,
							originCampaign:process.env.REACT_APP_ORIGIN_CAMPAIGN, lookingForOnlineClass:isOnlineClass
						}
						const SubmitNewFormData = JSON.stringify(NewFormData)
						// setTimeout(() => {
						axios.post('https://ser.ay.tudotechnologies.com/magicFood/registerUserPayNow/', SubmitNewFormData,
							{
								headers: {
									"Content-Type": "application/json",
								},
							}
						)
							.then((res) => {
								console.log("Data",res)
								logEvent(analytics,"Conversion Event Red2",data)
								props.onHide();
								history.push('/thankyou')
								
							})
							.catch((err) => console.log(err));

						// setTimeout(() => {
						// 	popupCenter(paymentLink, "Payment for Red", 600, 700);
						// }, 500);
						// props.ThankYouPopUpShow()
						// }, 5000);
					// }
				// }
				// window.open(paymentLink, "_parent");
			}})
		// .catch((err) => console.log(err));

	};


	const TeleCRMLeads = async () => {

        const hostName = window.location.hostname
        const url = `https://api.telecrm.in/enterprise/688c705178fd22989f75ecef/autoupdatelead`;
        const token = 'c2b2c8c2-102b-47e8-b491-1db5763080421754305303538:aa287813-6838-442c-a5d8-4f247b99e32f'
        const params = new URLSearchParams(window.location.search);

        const data = {
            fields: {
            name: formData.name,
            phone: `${formData.isd}-${formData.mobile}`,
            email: formData.email,
            utm_source: params.get("utm_source") || "",
            utm_medium: params.get("utm_medium") || "",
            utm_campaign: params.get("utm_campaign") || "",
            gclid: params.get("gclid") || "",
            },
            actions: [
            {
                type: "SYSTEM_NOTE",
                text: `Lead Source: Red2 Page - Book a free trial (${hostName})`
            }
            ]
        };

        const config = {
            headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
            }
        };

        try {
            const response = await axios.post(url, data, config);
            return response.data;
        } catch (error) {
            console.error("Error updating lead:", error);
            throw error;
        }
    }





	return (
		<div className='congratulations pt-4'>
			<div className='header'>
				<div className='px-5 d-flex align-items-center justify-content-center position-relative'>
					<h1 className='title'>Hello! </h1>
					<p
						onClick={() => {
							props.onHide();
						}}
						className='position-absolute'
						style={{ right: 0, top: 0, paddingRight: "50px" }}>
						<img
							src='assets/close.svg'
							alt=''
							className='img-fluid'
						/>
					</p>
				</div>
				<div className='px-4 brief d-flex align-items-center justify-content-center'>
					{/* Please enter your details and our representative will contact you to book your FREE RED class! */}
					Book your Free trial now.
				</div>

			</div>
			<div className='px-4 '>
				<div className='d-flex flex-column mt-3'>
					<label htmlFor='Name'>Name</label>
					<input
						onChange={handleFormData}
						placeholder='Enter your name'
						type='text'
						id='Name'
						name='name'
					/>
				</div>
				<div className='d-flex flex-column mt-3'>
					<label htmlFor='Email'>Email Address</label>
					<input
						onChange={handleFormData}
						name='email'
						placeholder='Enter your email'
						type='email'
						id='Email'
					/>
				</div>
				{/* <div className='d-flex flex-column mt-3'>
					<label htmlFor='Mobile'>Phone Number</label>
					<input
						onChange={handleFormData}
						placeholder='Enter your mobile'
						type='text'
						id='Mobile'
						name='mobile'
					/>
				</div> */}
				<div className='d-flex flex-column mt-3'>
					<label htmlFor="email">Phone No</label>


					<PhoneInput
						// @ts-ignore
						className="joinNowinput"
						onChange={handleChange}
						placeholder='Enter your mobile'
						type='text'
						id='Mobile'
						country={'ae'}
					/>

				</div>

				<div className='d-flex flex-column mt-3'>
					<label htmlFor="email">Are you looking for online yoga classes?</label>
					<div className="radio-wrapper">
						<div className="radio-container">
							<input type="radio"
							name="onlineClass"
							value="yes"
							checked={isOnlineClass === 'yes'}
							onChange={() => setIsOnlineClass('yes')}/>
							Yes
						</div>
						<div className="radio-container">
							<input type="radio"
							name="onlineClass"
							value="no"
							checked={isOnlineClass === 'no'}
							onChange={() => setIsOnlineClass('no')}/>
							No
						</div>
					</div>
				</div>

				<div className='d-flex align-items-center justify-content-center  '>
					{Loader ? <button
						disabled={isDisable}
						onClick={handleSubmitPay}
						className='proceedBtn'>
						Proceed
					</button> :

						<button
							onClick={handleSubmitPay}
							className='loadingButton'>
							<ReactLoading type={"spinningBubbles"} height={38} width={38} color={"#F21623"} />

						</button>}

				</div>
				{error && <div className="warning">
					<div className="d-flex justify-content-center align-items-center ">
						<img src="assets/Warning.png" alt="" />
						<p>{error}</p>
					</div>

				</div>}
			</div>
		</div>
	);
}
